import { Award, CheckCircle, Clock, Shield, Star, Users } from "lucide-react";

export const services = [
  {
    id: 1,
    title: "Supply Chain & Operational Services",
    description:
      "Reliable procurement and supply across construction materials, food commodities, and institutional supplies. Strong logistics ensure timely delivery and consistent quality.",
    image: "/images/innovation.jpg",
  },
  {
    id: 2,
    title: "Tendering & Bidding Excellence",
    description:
      "Competitive tendering with full transparency and regulatory compliance. Upon award, seamless execution through defined strategies and rigorous quality assurance.",
    // image: "/images/projectImplementation.jpg",
    image:
      "https://i.pinimg.com/1200x/0b/c1/5d/0bc15d66b6559bd87581aedf2b4d1ebb.jpg",
  },
  {
    id: 3,
    title: "Project Execution & Innovation",
    description:
      "Results-driven delivery through structured planning, modern technologies, and sustainable practices — completed on time and within budget.",
    // image: "/images/innovation.jpg",
    image: "/images/projectImplementation.jpg",
  },
  {
    id: 4,
    title: "Consultancy & Technical Support",
    description:
      "Multidisciplinary services across engineering, transport, garment production, and project management — plus field supervision, training, and coordination.",
    image: "/images/Consultancy.jpg",
  },
  {
    id: 5,
    title: "Animal Feed Production",
    subTitle: "Agribusiness",
    description:
      "Quality-certified animal feed manufactured at our Gatsibo District factory. We produce a full range of feeds for poultry, swine, and dairy cattle — formulated to maximise animal health and productivity.",
    // image: "/images/irigation.jpg",
    image:
      "https://i.pinimg.com/1200x/c7/48/6e/c7486e17101054423bb8ded68225212d.jpg",
    // products: [
    //   "Layer Starter Mash",
    //   "Pre-Starter Mash",
    //   "Grower Mash",
    //   "Pre-Layer Mash",
    //   "Layer 2",
    //   "Broiler Starter Mash",
    //   "Broiler Starter Pellet",
    //   "Broiler Finisher Mash",
    //   "Broiler Finisher Pellet",
    //   "Pig Starter Mash",
    //   "Pig Finisher Mash",
    //   "Lactating Sows",
    //   "Dairy Meal Mash",
    // ],
    // factoryLocation: "Gatsibo District, Eastern Province, Rwanda",
  },
  {
    id: 6,
    title: "Construction Services",
    description:
      "Full-scale construction solutions for residential and commercial properties. You provide the requirements and materials, and we handle the complete construction process — from foundation to finishing — with skilled labour and quality workmanship.",
    // image: "/images/construction.jpg", // Update with actual image path
    image:
      "https://i.pinimg.com/1200x/49/85/22/4985225517780f82d804462733572cb9.jpg", // Update with actual image path
  },
  {
    id: 7,
    title: "Transport & Logistics",
    description:
      "Reliable transport services for both goods and people. Whether you need to move cargo across locations or arrange passenger transport for events and ceremonies, we provide well-maintained vehicles and professional drivers to ensure safe and timely delivery.",
    image:
      "https://i.pinimg.com/736x/16/81/bf/1681bfdaca3c9fed3c1417683cb7ca39.jpg", // Update with actual image path
  },
];

export const our_customers = [
  {
    image:
      "https://i.pinimg.com/736x/17/c1/d9/17c1d903910937ecfd18943ee06279c2.jpg",
    // "/logo-fav.jpg",
    name: "Amina K.",
  },
  {
    image:
      // "https://i.pinimg.com/1200x/d7/4c/10/d74c1008b4642a03137ef315087a9dab.jpg",
      "/logo-fav.jpg",
    name: "Jack M.",
  },
  {
    image:
      "https://i.pinimg.com/736x/fb/23/63/fb2363972fe0487685467f288cad0f6c.jpg",
    // "/logo-fav.jpg",
    name: "Elena V.",
  },
  {
    image:
      // "https://i.pinimg.com/1200x/7d/9a/68/7d9a68865d3f1688c2a7eec2b7bdf8da.jpg",
      "/logo-fav.jpg",
    name: "Samuel T.",
  },
];

export const testimonials = [
  {
    quote:
      "Hexad transformed our digital infrastructure, resulting in 40% cost savings.",
    name: "Sarah Chen",
    role: "CTO, TechInnovate",
    image: "/logo-fav.jpg",
    // "https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
  },
  {
    quote:
      "Working with Hexad streamlined our workflows and boosted productivity across all departments.",
    name: "David Okoro",
    role: "Operations Manager, GlobalReach",
    image: "/logo-fav.jpg",
    // "https://i.pinimg.com/736x/17/c1/d9/17c1d903910937ecfd18943ee06279c2.jpg",
  },
  {
    quote:
      "Their engineering team delivered scalable solutions that supported our rapid growth.",
    name: "Elena Petrova",
    role: "Head of Engineering, BuildSmart",
    image: "/logo-fav.jpg",
    // "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
  },
  {
    quote:
      "Hexad’s consulting expertise helped us modernize legacy systems without disrupting operations.",
    name: "Michael Johnson",
    role: "CIO, FinEdge",
    image: "/logo-fav.jpg",
    // "https://i.pinimg.com/736x/17/c1/d9/17c1d903910937ecfd18943ee06279c2.jpg",
  },
  {
    quote:
      "The project management support ensured our construction projects were delivered on time and on budget.",
    name: "Amina Yusuf",
    role: "Project Director, ConstructPro",
    image: "/logo-fav.jpg",
    // "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
  },
];

export const teamMembers = [
  {
    name: "Usanase Denis",
    role: "Chief Executive Officer",
    bio: "Provides strategic leadership and vision for Hexad, driving innovation, partnerships, and sustainable growth across technology, engineering, and business transformation services.",
    email: "denis.usanase@hexad.co.rw",
    image: "/team/denis_one.jpg",
    socials: {
      linkedin: "#",
      twitter: "#",
    },
  },
  {
    name: "Ndizera Claude",
    role: "Executive Director",
    bio: "Oversees operations and client engagement at Hexad, ensuring delivery excellence and fostering long-term relationships with industry partners and stakeholders.",
    email: "claude.ndizera@hexad.co.rw",
    image: "/team/claude.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Uzabumwana Liliane",
    role: "Administrative Assistant",
    bio: "Supports Hexad’s executive team with administrative coordination, communication management, and organizational efficiency to keep projects and operations running smoothly.",
    email: "liliane.uzabumwana@hexad.co.rw",
    image: "/team/liliane.jpg",
    socials: {
      linkedin: "#",
    },
  },
  // Below for the team
  {
    name: "Peter Karasira",
    role: "Managing Director",
    bio: "Leads strategic direction and operational management at Hexad, ensuring the company’s vision is realized through effective leadership, innovation, and stakeholder engagement across all service areas.",
    email: "peter.karasira@hexad.co.rw",
    image: "/team/Peter.png",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Janviere Nyirabagirishya",
    role: "Head of Corporate Services",
    bio: "Oversees corporate strategy execution, administrative excellence, and service delivery optimization at Hexad. Ensures alignment between operational functions and business objectives while fostering a productive work environment.",
    email: "janviere.nyirabagirishya@hexad.co.rw",
    // image: "/team/immaculate.jpg",
    image: "/logo-fav.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Chrispine Musanabera",
    role: "Chief Accountant",
    bio: "Directs financial planning, accounting operations, and fiscal management at Hexad. Implements robust financial controls, monitors performance metrics, and provides strategic insights for informed decision-making and sustainable financial health.",
    email: "chrispine.musanabera@hexad.co.rw",
    image: "/team/chrispine.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Gregoire Nsengiyunva",
    role: "Compliance and Administration Officer",
    bio: "Champions regulatory compliance, risk management, and administrative protocols at Hexad. Develops and implements policies that ensure operational integrity while supporting efficient organizational processes and governance standards.",
    email: "gregoire.nsengiyumva@hexad.co.rw",
    image: "/team/gregoire.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Dusabe François",
    role: "Bids and Commercial Officer",
    bio: "Coordinates proposal development, commercial documentation, and bid submission processes at Hexad. Supports competitive positioning and client engagement through meticulous preparation of tender responses and commercial materials.",
    email: "francois.dusabe@hexad.co.rw",
    image: "/team/dusabe.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "J.Happy Manyenzi",
    role: "Digital & IT Officer",
    bio: "Leads technology infrastructure management, digital systems maintenance, and IT support services at Hexad. Implements technological solutions that enhance operational efficiency and support the company's digital transformation journey.",
    email: "jhappy.manyenzi@hexad.co.rw",
    image: "/team/happy.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Theogene Hitimana",
    role: "Driver",
    bio: "Ensures reliable transportation services and logistical support for Hexad's operations. Maintains vehicle safety standards and provides efficient mobility solutions that support the team's field activities and resource distribution.",
    email: "theodette.ninshuti@hexad.co.rw",
    image: "/team/hitimana.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Afia Yamfashije",
    role: "Production Manager",
    bio: "Oversees production processes, quality control, and operational efficiency at Hexad. Implements best practices in manufacturing and project execution to ensure timely delivery of high-quality outcomes that meet client expectations.",
    email: "afia.yamfashije@hexad.co.rw",
    image: "/team/Afia.png",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Theodette Ninshuti",
    role: "Factory Accountant",
    bio: "Manages financial reporting, budgeting, and accounting operations for the factory at Hexad. Ensures compliance with financial regulations and provides accurate insights for strategic decision-making.",
    email: "theodette.ninshuti@hexad.co.rw",
    image: "/team/Theodete.png",
    socials: {
      linkedin: "#",
    },
  },
  //
  {
    name: "Patrick Nshimiyimana",
    role: "Tenders and Contracts Coordinator",
    bio: "Coordinates procurement processes and contract management to ensure compliance and value for Hexad Ltd. Oversees tender documentation, supplier engagement, and contract execution to support operational efficiency and strategic sourcing.",
    email: "patrick.nshimiyimana@hexad.co.rw",
    image: "/logo-fav.jpg",
    socials: {
      linkedin: "#",
    },
  },
  {
    name: "Gatete Prosper",
    role: "Business Development Manager",
    bio: "Drives strategic partnerships and market expansion initiatives for Hexad Ltd. Identifies growth opportunities, nurtures client relationships, and develops tailored solutions that align with the company’s vision and operational goals.",
    email: "gatete.prosper@hexad.co.rw",
    image: "/team/gatete.png",
    socials: {
      linkedin: "#",
    },
  },
];

export const caseStudies = [
  {
    title: "Rwanda Correctional Service — Materials Supply",
    result: "3 Districts Served",
    duration: "Completed",
    category: "Construction",
  },
  {
    title: "Institutional Food Supply Programme",
    result: "12+ Contracts",
    duration: "Nationwide",
    category: "Food Supply",
  },
  {
    title: "TTC Muhanga — Food Store & Kitchen Build",
    result: "On Time & Budget",
    duration: "Completed",
    category: "Construction",
  },
];

// export const projects = [
//   {
//     title: "Smart Irrigation System",
//     category: "Agribusiness",
//     img: "/images/irigation.jpg",
//     // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
//     desc: "A fully automated irrigation solution enhancing water efficiency for farmers.",
//     duration: "6 Months",
//     team: "8 Members",
//   },
//   {
//     title: "Road Construction Project",
//     category: "Construction",
//     img: "/images/road.jpg",
//     // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
//     desc: "High-quality road development improving transportation and community access.",
//     duration: "12 Months",
//     team: "15 Members",
//   },
//   {
//     title: "Digital Transformation Portal",
//     category: "Technology",
//     img: "/images/digital.jpg",
//     // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
//     desc: "A modern digital platform helping businesses automate operations.",
//     duration: "4 Months",
//     team: "6 Members",
//   },
//   {
//     title: "Garment Production Line",
//     category: "Manufacturing",
//     img: "/images/garmet.jpg",
//     // img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
//     desc: "Mass production of industrial uniforms and quality textile products.",
//     duration: "8 Months",
//     team: "12 Members",
//   },
//   {
//     title: "Renewable Energy Installation",
//     category: "Engineering",
//     img: "/images/renew.jpg",
//     // img: "https://i.pinimg.com/736x/68/5e/8a/685e8ab1c0eab0735a4c1bc951116e66.jpg",
//     desc: "Solar power systems implementation for sustainable energy solutions.",
//     duration: "5 Months",
//     team: "10 Members",
//   },
//   {
//     title: "Urban Transport System",
//     category: "Transport",
//     img: "/images/urban.jpg",
//     // img: "https://i.pinimg.com/736x/35/47/48/354748471cbad482eccf036d1db1a86c.jpg",
//     desc: "Modern transportation infrastructure development for urban mobility.",
//     duration: "18 Months",
//     team: "20 Members",
//   },
// ];

export const projects = [
  {
    title: "Supply of Construction Materials - Nyamasheke",
    category: "Construction Materials",
    img: "https://i.pinimg.com/736x/a6/0d/21/a60d21a0e64a84176bc78eae996780a7.jpg",
    desc: "Supply of construction materials to the Rwanda Correctional Service in Nyamasheke District.",
    duration: "Completed Project",
    team: "Procurement Team",
  },
  {
    title: "Supply of Construction Materials - Rwamagana",
    category: "Construction Materials",
    img: "https://i.pinimg.com/1200x/36/df/bd/36dfbd69ae843270294ae63ae75152b6.jpg",
    desc: "Supply of construction materials to the Rwanda Correctional Service in Rwamagana District.",
    duration: "Completed Project",
    team: "Procurement Team",
  },
  {
    title: "Supply of Construction Materials - Nyanza",
    category: "Construction Materials",
    img: "https://i.pinimg.com/736x/2e/5f/06/2e5f06f0bd6a7c849891e30d1d1773f2.jpg",
    desc: "Supply of construction materials to the Rwanda Correctional Service in Nyanza District.",
    duration: "Completed Project",
    team: "Procurement Team",
  },
  {
    title: "Supply of Construction Materials - KEFA Sport Ltd",
    category: "Construction Materials",
    img: "https://i.pinimg.com/1200x/ce/1b/a7/ce1ba737bede31b880661e16a6adb864.jpg",
    desc: "Supply of construction materials to KEFA Sport Ltd.",
    duration: "Completed Project",
    team: "Procurement Team",
  },

  {
    title: "Food Supply - Musanze District",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/65/4a/87/654a87bb72adee1fe41216c45b57875e.jpg",
    desc: "Supply of food products to Musanze District.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - Gicumbi District",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/96/41/85/964185cdeacc944952a23827aef085c7.jpg",
    desc: "Supply of food products to Gicumbi District.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - Ruhango District",
    category: "Food Supply",
    img: "https://i.pinimg.com/736x/7f/90/86/7f9086f4eeaa8aa771243e8b0663905e.jpg",
    desc: "Supply of food products to Ruhango District.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - Nyamasheke District",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/17/95/a0/1795a0d735f8d295283b1e163c44054f.jpg",
    desc: "Supply of food products to Nyamasheke District.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - Rambura-Filles Secondary School",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/c5/d3/a0/c5d3a088f2160472965e533d0abeef13.jpg",
    desc: "Supply of food products to Rambura-Filles Secondary School.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - EPI Gatsata I",
    category: "Food Supply",
    img: "https://i.pinimg.com/736x/1a/8f/18/1a8f184a599ffbe7ece86df16fa4dfcf.jpg",
    desc: "Supply of food products to EPI Gatsata I.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - EPI Gatsata II",
    category: "Food Supply",
    img: "https://i.pinimg.com/736x/45/07/38/450738bb68a4cde35e00e5cc6ed1ec09.jpg",
    desc: "Supply of food products to EPI Gatsata II.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - EPI Kamuyange",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/8d/8e/e7/8d8ee7bffbe9f5982d5d5c26b776d18a.jpg",
    desc: "Supply of food products to EPI Kamuyange.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - Groupe Scolaire Shango",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/ed/45/3b/ed453b0f441648fac5b81e33f5d597fa.jpg",
    desc: "Supply of food products to Groupe Scolaire Shango.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - EPI Bweramvura Catholique",
    category: "Food Supply",
    img: "https://i.pinimg.com/736x/d0/c3/90/d0c390727b414e376cf4fb67680a6e10.jpg",
    desc: "Supply of food products to EPI Bweramvura Catholique.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - EPI Rusagara",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/15/35/3e/15353ed0b6de9533ae1cd80a9ea668b3.jpg",
    desc: "Supply of food products to EPI Rusagara.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - EPI Rwiminazi",
    category: "Food Supply",
    img: "https://i.pinimg.com/1200x/25/89/68/258968178401c0b68b1c63e9edefc8e2.jpg",
    desc: "Supply of food products to EPI Rwiminazi.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },
  {
    title: "Food Supply - ADRA Rwanda",
    category: "Food Supply",
    img: "https://i.pinimg.com/736x/44/7b/76/447b76e565e7783fb794182ec6420fa9.jpg",
    desc: "Supply of food products to ADRA Rwanda.",
    duration: "Completed Project",
    team: "Food Supply Team",
  },

  {
    title: "Construction of Food Store & Kitchen",
    category: "Construction Works",
    img: "https://i.pinimg.com/1200x/72/d1/0f/72d10ff0d9f22542c67d9ed6f1320ace.jpg",
    desc: "Construction of a food storage facility and kitchen for TTC Muhanga.",
    duration: "Completed Project",
    team: "Construction Team",
  },
  {
    title: "Ngoma-Ramiro Road Gutter Construction",
    category: "Construction Works",
    img: "https://i.pinimg.com/1200x/41/37/87/413787dcb66d5c20d0b48376ed837770.jpg",
    desc: "Construction of a road gutter on the Ngoma-Ramiro Road for Edge Construction Ltd.",
    duration: "Completed Project",
    team: "Construction Team",
  },
  {
    title: "Supply of Stones - Muhanga",
    category: "Construction Works",
    img: "https://i.pinimg.com/1200x/3c/16/77/3c1677e0f184305b5e5a53bda06a654e.jpg",
    desc: "Supply of construction stones to a Chinese company in Muhanga.",
    duration: "Completed Project",
    team: "Construction Team",
  },

  {
    title: "Animal Feed Supply",
    category: "Agriculture",
    img: "https://i.pinimg.com/1200x/01/c6/30/01c63050769a7b7124885228d2e86911.jpg",
    desc: "Supply of animal feed for hens and chickens to RAB Muhanga Station.",
    duration: "Completed Project",
    team: "Agriculture Team",
  },
  {
    title: "School Desks Supply",
    category: "Furniture Supply",
    img: "https://i.pinimg.com/1200x/4c/90/26/4c902612cdb6dd1141290b12ad0dced0.jpg",
    desc: "Supply of desks for pupils in Nyanza District.",
    duration: "Completed Project",
    team: "Supply Team",
  },
  {
    title: "Firewood Supply",
    category: "Energy Supply",
    img: "https://i.pinimg.com/736x/70/a3/26/70a3260fc254d7d39b196640372659ed.jpg",
    desc: "Supply of firewood to EAV Ntendezi.",
    duration: "Completed Project",
    team: "Supply Team",
  },
];

export const whyChooseUs = [
  {
    icon: <Shield className="w-5 h-5" />,
    title: "Integrity & Accountability",
    desc: "Honest, transparent operations aligned to standards.",
  },
  {
    icon: <Award className="w-5 h-5" />,
    title: "Proven Expertise",
    desc: "Skilled teams with strong technical know-how.",
  },
  {
    icon: <Users className="w-5 h-5" />,
    title: "Innovation & Efficiency",
    desc: "Modern solutions guided by smart technology.",
  },
  {
    icon: <Clock className="w-5 h-5" />,
    title: "Timely Delivery",
    desc: "Projects completed on schedule and within budget.",
  },
  {
    icon: <Star className="w-5 h-5" />,
    title: "Quality Assurance",
    desc: "Strict quality control for durable outcomes.",
  },
  {
    icon: <CheckCircle className="w-5 h-5" />,
    title: "Comprehensive Services",
    desc: "End-to-end support from planning to execution.",
  },
];

export const fullProject = {
  title: "Smart Irrigation System",
  category: "Agribusiness",
  img: "https://i.pinimg.com/1200x/25/30/04/25300440c5b32795f496a5f1e9425f7d.jpg",
  desc: "A fully automated irrigation solution designed to optimize water usage, monitor soil conditions, and support farmers with real-time decision insights.",
  duration: "6 Months",
  team: "8 Members",
  slug: "smart-irrigation-system", // for detail page routing

  // NEW extended fields:
  overview:
    "The Smart Irrigation System project focuses on increasing water efficiency and crop productivity by integrating IoT-enabled sensors, automated valve control, and data-driven decision support. Designed for small-to-medium-scale farmers, the system reduces water waste by up to 40% and provides real-time insights through a mobile dashboard.",

  objectives: [
    "Reduce water consumption using automated irrigation cycles.",
    "Monitor soil moisture, humidity, and temperature in real time.",
    "Provide farmers with actionable data through an intuitive dashboard.",
    "Ensure the system works in remote areas with low internet connectivity.",
  ],

  technologies: [
    "IoT Sensors (Soil Moisture, DHT11, Water Flow)",
    "Solar-Powered Microcontroller Unit (ESP32)",
    "LoRaWAN Gateway for Long-Range Communication",
    "Node.js & Express Backend",
    "React Dashboard Interface",
    "Firebase Cloud Messaging (Real-time alerts)",
  ],

  features: [
    "AI-driven irrigation scheduling",
    "Mobile alerts for moisture thresholds",
    "Remote valve control",
    "Water consumption analytics",
    "Offline fallback mode",
  ],

  results: [
    "40% reduction in water usage in pilot farms",
    "20–30% increase in crop yield due to optimized irrigation",
    "50+ farmers onboarded in the first deployment cycle",
    "Reduced manual labor hours by 60%",
  ],

  gallery: [
    "https://i.pinimg.com/1200x/33/b2/23/33b22380b6f1d1492f22b2dc2d47cc96.jpg",
    "https://i.pinimg.com/1200x/33/b2/23/33b22380b6f1d1492f22b2dc2d47cc96.jpg",
    "https://i.pinimg.com/1200x/33/b2/23/33b22380b6f1d1492f22b2dc2d47cc96.jpg",
  ],

  client: "GreenHarvest Cooperative – Northern Agricultural Zone",
  location: "Garu-Tempane District, Ghana",
  completionDate: "2024",
};

export const fullServices = {
  id: 1,
  title: "Technology Solutions",
  description:
    "Custom software development, digital transformation, and scalable IT infrastructure tailored to modern business needs.",
  image:
    "https://i.pinimg.com/736x/b9/b6/0e/b9b60eb215193ce939ca6721601a846b.jpg",

  // --- DETAIL PAGE CONTENT ---
  longDescription:
    "Our Technology Solutions service empowers organizations to modernize operations, enhance efficiency, and embrace innovation. From enterprise-grade software platforms to cloud-native infrastructure and automation workflows, we deliver end-to-end solutions built for long-term scalability and performance.",

  objectives: [
    "Modernize legacy systems and processes.",
    "Build scalable, secure, and cloud-ready infrastructure.",
    "Enhance customer experience through digital transformation.",
    "Increase operational efficiency using automation technologies.",
  ],

  features: [
    "Custom Web & Mobile Development",
    "Cloud Migration & Infrastructure Setup",
    "API Development & Integrations",
    "Automation & Workflow Optimization",
    "Cybersecurity & System Hardening",
    "IT Consulting & Managed Support",
  ],

  benefits: [
    "Reduced operational costs",
    "Improved efficiency and response time",
    "Increased data security and reliability",
    "Future-ready digital ecosystems",
  ],

  technologies: [
    "React",
    "Node.js",
    "AWS",
    "Docker",
    "PostgreSQL",
    "Kubernetes",
    "Python",
  ],

  industriesServed: [
    "Finance",
    "Healthcare",
    "Retail",
    "Agriculture",
    "Public Sector",
  ],

  gallery: [
    "https://i.pinimg.com/1200x/7c/51/ad/7c51adfbc4abc24424318a5c37de4336.jpg",
    "https://i.pinimg.com/1200x/7c/51/ad/7c51adfbc4abc24424318a5c37de4336.jpg",
    "https://i.pinimg.com/1200x/7c/51/ad/7c51adfbc4abc24424318a5c37de4336.jpg",
  ],
};

export const fullServicesData = [
  {
    id: 1,
    title: "Supply Chain & Operational Services",
    subtitle: "Supply Chain",
    image: "/images/innovation.jpg",
    description:
      "Reliable procurement and supply across construction materials, food commodities, and institutional supplies. Strong logistics ensure timely delivery and consistent quality.",
    overview:
      "HEXAD LTD provides reliable supply chain and operational services that ensure organizations receive the materials, commodities, and supplies they need efficiently, cost-effectively, and on schedule. Our services combine procurement expertise, supplier coordination, logistics management, and operational support to deliver consistent value to clients across Rwanda. We specialize in the supply of construction materials, food commodities, institutional supplies, office stationery, and specialized products required by public institutions, NGOs, and private sector organizations.",
    whatWeProvide: [
      "Procurement and sourcing",
      "Supplier coordination and management",
      "Logistics planning and execution",
      "Transportation and delivery",
      "Contract supply management",
      "Institutional procurement support",
      "Operational coordination for large-scale supply projects",
    ],
    problemsSolved: [
      "Reducing procurement delays through established supplier relationships",
      "Improving supply reliability and continuity",
      "Ensuring timely delivery of goods and materials",
      "Minimizing operational disruptions",
      "Supporting compliance with procurement requirements",
      "Providing coordinated logistics for multi-location projects",
    ],
    features: [
      {
        title: "Procurement & Sourcing",
        description:
          "HEXAD coordinates the sourcing and procurement of materials, commodities, and institutional supplies required by clients across multiple sectors.",
      },
      {
        title: "End-to-End Supply Coordination",
        description:
          "From supplier engagement to final delivery, we manage the operational processes required to ensure successful contract execution.",
      },
      {
        title: "Transportation & Delivery",
        description:
          "Our logistics network supports timely transportation and delivery across multiple districts and regions of Rwanda.",
      },
      {
        title: "Inventory & Supply Coordination",
        description:
          "We support clients in maintaining consistent supply availability and managing recurring procurement requirements.",
      },
    ],
    industriesServed: [
      {
        name: "Government Institutions",
        description:
          "We have supplied goods and materials to government entities including Rwanda Correctional Service, district administrations, and government agricultural institutions.",
      },
      {
        name: "NGOs & Development Organizations",
        description:
          "We support NGOs with procurement and supply services that meet donor and organizational standards.",
      },
      {
        name: "Construction & Infrastructure",
        description:
          "We provide construction materials and operational support for infrastructure and civil works projects.",
      },
      {
        name: "Agriculture",
        description:
          "We have supplied agricultural-related products, including animal feed for government agricultural programs.",
      },
      {
        name: "Education",
        description:
          "We support schools and educational institutions with food supplies, furniture, stationery, and operational procurement needs.",
      },
    ],
    whyChooseHexad: [
      {
        title: "Strong Supplier Network",
        description:
          "Our procurement experience enables us to identify and engage reliable suppliers capable of meeting project requirements.",
      },
      {
        title: "Timely Delivery",
        description:
          "We maintain strong logistics coordination to ensure goods are delivered according to agreed schedules.",
      },
      {
        title: "Quality Assurance",
        description:
          "We apply quality control measures throughout procurement and delivery processes to ensure client satisfaction.",
      },
      {
        title: "Nationwide Coverage",
        description:
          "HEXAD has successfully executed supply contracts across multiple districts throughout Rwanda.",
      },
    ],
    portfolioHighlights: [
      "12+ food supply contracts nationwide",
      "Construction materials supplied to Rwanda Correctional Service facilities in Nyanza, Nyamasheke, and Rwamagana",
      "Food supply contracts delivered across Musanze, Gicumbi, Ruhango, and Nyamasheke districts",
      "Specialized supply contracts for government and institutional clients",
      "Office stationery supply for schools, institutions, and private organizations",
    ],
    geographicCoverage: [
      "Kigali",
      "Musanze",
      "Gicumbi",
      "Ruhango",
      "Nyamasheke",
      "Nyanza",
      "Rwamagana",
      "Muhanga",
      "Additional districts across Rwanda",
    ],
    majorClients: [
      "Rwanda Correctional Service",
      "ADRA Rwanda",
      "District Governments",
      "Schools and Educational Institutions",
      "RAB Muhanga Station",
    ],
    faq: [
      {
        q: "Can HEXAD handle urgent procurement requests?",
        a: "Yes. Our procurement and logistics teams work to respond quickly to urgent supply requirements while maintaining quality and compliance standards.",
      },
      {
        q: "Do you supply imported products?",
        a: "Where required and subject to procurement regulations, HEXAD can coordinate sourcing through approved suppliers and partners.",
      },
      {
        q: "Can HEXAD manage recurring supply contracts?",
        a: "Yes. We support recurring and long-term supply contracts for government institutions, NGOs, schools, and private organizations.",
      },
      {
        q: "Do you provide nationwide delivery?",
        a: "Yes. HEXAD has experience delivering supplies across multiple districts throughout Rwanda.",
      },
      {
        q: "How do you ensure quality?",
        a: "We implement supplier verification, procurement controls, and delivery inspections to ensure products meet required standards.",
      },
    ],
  },
  {
    id: 2,
    title: "Tendering & Bidding Excellence",
    subtitle: "Tendering",
    image:
      "https://i.pinimg.com/1200x/0b/c1/5d/0bc15d66b6559bd87581aedf2b4d1ebb.jpg",
    description:
      "Competitive tendering with full transparency and regulatory compliance. Upon award, seamless execution through defined strategies and rigorous quality assurance.",
    overview:
      "HEXAD LTD provides comprehensive tendering and bidding services designed to help organizations successfully compete for and secure contracts in both the public and private sectors. Our approach combines strategic planning, regulatory compliance, technical expertise, and rigorous quality assurance to maximize competitiveness and ensure successful contract execution. We support clients throughout the tender lifecycle, from opportunity identification and bid preparation to submission management and post-award implementation support.",
    whatWeProvide: [
      "Tender opportunity identification",
      "Bid strategy development",
      "Technical proposal preparation",
      "Financial proposal preparation",
      "Compliance verification",
      "Documentation management",
      "Tender submission coordination",
      "Post-award implementation planning",
    ],
    problemsSolved: [
      "Improving bid quality and competitiveness",
      "Ensuring compliance with procurement regulations",
      "Reducing administrative errors in submissions",
      "Strengthening technical and financial proposals",
      "Managing submission deadlines effectively",
      "Supporting successful contract implementation after award",
    ],
    features: [
      {
        title: "Tender Opportunity Identification",
        description:
          "We monitor and evaluate procurement opportunities that align with client capabilities and strategic objectives.",
      },
      {
        title: "Bid Preparation",
        description:
          "Our team coordinates the preparation of complete, accurate, and competitive tender submissions.",
      },
      {
        title: "Technical Proposal Development",
        description:
          "We develop structured technical proposals that clearly demonstrate capacity, methodology, experience, and project understanding.",
      },
      {
        title: "Compliance Review",
        description:
          "Every submission undergoes a compliance review to ensure all requirements, certifications, and supporting documents are included.",
      },
      {
        title: "Submission Management",
        description:
          "We coordinate document packaging, submission schedules, and procurement communications to ensure timely and successful delivery.",
      },
      {
        title: "Post-Award Support",
        description:
          "Upon contract award, we assist with planning, mobilization, implementation strategies, and quality assurance processes.",
      },
    ],
    industriesServed: [
      {
        name: "Public Sector",
        description:
          "Support for government procurement opportunities at national and district levels.",
      },
      {
        name: "Construction & Infrastructure",
        description:
          "Tender preparation and contract execution support for construction and civil works projects.",
      },
      {
        name: "Agriculture",
        description:
          "Procurement and supply tenders related to agricultural inputs, livestock support, and institutional programs.",
      },
      {
        name: "Education",
        description:
          "Support for educational infrastructure, food supply, furniture, and institutional procurement projects.",
      },
      {
        name: "Development & NGO Projects",
        description:
          "Assistance with procurement opportunities funded by NGOs, development agencies, and donor-funded programs.",
      },
    ],
    whyChooseHexad: [
      {
        title: "Regulatory Compliance",
        description:
          "We maintain strict adherence to procurement regulations, tender requirements, and ethical business practices.",
      },
      {
        title: "Proven Execution Capability",
        description:
          "Beyond winning contracts, HEXAD has demonstrated the ability to successfully implement awarded projects and supply agreements.",
      },
      {
        title: "Quality Assurance",
        description:
          "Rigorous review processes ensure that submissions meet both technical and administrative requirements.",
      },
      {
        title: "Multi-Sector Experience",
        description:
          "Experience across construction, supply chain management, agriculture, education, and institutional procurement.",
      },
      {
        title: "End-to-End Support",
        description:
          "From tender identification through contract execution, we provide complete support throughout the procurement lifecycle.",
      },
    ],
    portfolioHighlights: [
      "Food supply contracts across multiple districts",
      "Construction materials supply for government institutions",
      "Civil works and infrastructure support projects",
      "Specialized supply contracts for public institutions",
      "Educational infrastructure and operational support projects",
      "100% delivery compliance across completed contracts",
      "Repeat engagements with government and NGO clients",
    ],
    geographicCoverage: [
      "Kigali",
      "Musanze",
      "Gicumbi",
      "Ruhango",
      "Nyamasheke",
      "Nyanza",
      "Rwamagana",
      "Muhanga",
    ],
    majorClients: [
      "Rwanda Correctional Service",
      "District Governments",
      "RAB Muhanga Station",
      "ADRA Rwanda",
      "Educational Institutions",
    ],
    faq: [
      {
        q: "Does HEXAD work with government institutions?",
        a: "Yes. HEXAD collaborates with government institutions, development partners, NGOs, and private sector organizations on various projects and supply contracts.",
      },
      {
        q: "Can HEXAD review existing proposals?",
        a: "Yes. We can assess existing tender submissions, identify weaknesses, and recommend improvements before submission.",
      },
      {
        q: "How quickly can HEXAD prepare a bid?",
        a: "Preparation timelines depend on the complexity of the tender. Early engagement allows for the strongest possible proposal.",
      },
      {
        q: "Do you support consortium and partnership bids?",
        a: "Yes. We can assist in coordinating bid documentation and proposal preparation involving multiple partners where permitted by procurement regulations.",
      },
      {
        q: "What happens after a contract is awarded?",
        a: "HEXAD supports implementation planning, resource mobilization, execution management, and quality assurance to ensure successful project delivery.",
      },
    ],
  },
  {
    id: 3,
    title: "Project Execution & Innovation",
    subtitle: "Projects",
    image: "/images/projectImplementation.jpg",
    description:
      "Results-driven delivery through structured planning, modern technologies, and sustainable practices — completed on time and within budget.",
    overview:
      "HEXAD LTD delivers projects through structured planning, effective resource management, modern technologies, and sustainable implementation practices. We transform concepts, designs, and strategic objectives into successful outcomes that create measurable value for clients and communities. Our project execution approach focuses on quality, efficiency, accountability, and timely delivery while maintaining strict compliance with project requirements and stakeholder expectations.",
    whatWeProvide: [
      "Construction and civil works execution",
      "Infrastructure development projects",
      "Supply chain and operational projects",
      "Agricultural support projects",
      "Educational infrastructure projects",
      "Institutional development initiatives",
      "Specialized procurement and implementation contracts",
    ],
    problemsSolved: [
      "Eliminating delayed implementation schedules through disciplined planning",
      "Resolving poor resource coordination and allocation challenges",
      "Addressing budget inefficiencies and cost overruns",
      "Improving quality control throughout project delivery",
      "Bridging communication gaps among stakeholders",
      "Strengthening monitoring and reporting systems",
    ],
    features: [
      {
        title: "Project Planning",
        description:
          "We develop detailed project plans that define objectives, timelines, resources, budgets, milestones, and performance indicators.",
      },
      {
        title: "Project Management",
        description:
          "Our team coordinates activities, stakeholders, contractors, suppliers, and project resources to ensure successful implementation.",
      },
      {
        title: "Resource Allocation",
        description:
          "We optimize human, financial, material, and operational resources to maximize project efficiency and performance.",
      },
      {
        title: "Monitoring & Evaluation",
        description:
          "We track progress through continuous monitoring, reporting, performance reviews, and corrective action planning.",
      },
      {
        title: "Technology Integration",
        description:
          "We utilize modern tools and technologies that improve communication, reporting, project visibility, and operational efficiency.",
      },
      {
        title: "Quality Assurance",
        description:
          "Strict quality control procedures ensure all project deliverables meet required standards and client expectations.",
      },
    ],
    industriesServed: [
      {
        name: "Construction & Infrastructure",
        description:
          "Execution of construction, civil works, and infrastructure development projects.",
      },
      {
        name: "Agriculture",
        description:
          "Support for agricultural supply, production, and institutional development initiatives.",
      },
      {
        name: "Public Institutions",
        description:
          "Implementation of government-funded and institutional projects at national and district levels.",
      },
      {
        name: "NGOs & Development Organizations",
        description:
          "Execution of donor-funded and community-focused development projects.",
      },
      {
        name: "Education",
        description:
          "Implementation of educational infrastructure, procurement, and institutional support projects.",
      },
    ],
    whyChooseHexad: [
      {
        title: "Structured Project Delivery",
        description:
          "Every project follows a clear implementation framework with defined objectives, milestones, responsibilities, and reporting mechanisms.",
      },
      {
        title: "On-Time Completion",
        description:
          "We prioritize disciplined scheduling, proactive coordination, and continuous monitoring to keep projects on track.",
      },
      {
        title: "Risk Management",
        description:
          "Potential risks are identified early, monitored continuously, and mitigated through practical response strategies.",
      },
      {
        title: "Multi-Sector Experience",
        description:
          "Experience across construction, supply chain management, agriculture, education, and institutional development projects.",
      },
      {
        title: "Sustainable Solutions",
        description:
          "We emphasize long-term value creation through environmentally responsible and community-focused approaches.",
      },
    ],
    portfolioHighlights: [
      "Construction materials supply projects across multiple districts",
      "Civil works and infrastructure support projects",
      "Institutional facility development projects",
      "Educational infrastructure support initiatives",
      "Agricultural supply and operational support projects",
      "100% delivery compliance on completed contracts",
      "Successful management of multiple concurrent projects",
      "Proven ability to execute projects across multiple regions of Rwanda",
    ],
    geographicCoverage: [
      "Kigali",
      "Muhanga",
      "Musanze",
      "Gicumbi",
      "Ruhango",
      "Nyamasheke",
      "Nyanza",
      "Rwamagana",
      "Additional districts nationwide",
    ],
    majorClients: [
      "Rwanda Correctional Service",
      "District Governments",
      "RAB Muhanga Station",
      "ADRA Rwanda",
      "Educational Institutions",
    ],
    faq: [
      {
        q: "Do you manage projects from start to finish?",
        a: "Yes. HEXAD provides complete project lifecycle management, from planning and mobilization to implementation, monitoring, reporting, and closeout.",
      },
      {
        q: "Can HEXAD rescue delayed projects?",
        a: "Yes. We can assess project challenges, identify root causes of delays, and implement recovery strategies to improve performance and completion timelines.",
      },
      {
        q: "Do you provide project monitoring services?",
        a: "Yes. Monitoring and evaluation are integral parts of our project execution approach and help ensure accountability, transparency, and progress tracking.",
      },
      {
        q: "How do you keep projects on schedule?",
        a: "Through structured planning, regular progress reviews, proactive coordination, resource management, and risk mitigation.",
      },
      {
        q: "How do you manage project risks?",
        a: "Risks are identified during planning, continuously monitored during implementation, and addressed through practical mitigation measures and contingency planning.",
      },
    ],
  },
  {
    id: 4,
    title: "Consultancy & Technical Support",
    subtitle: "Consultancy",
    image: "/images/Consultancy.jpg",
    description:
      "Multidisciplinary services across engineering, transport, garment production, and project management — plus field supervision, training, and coordination.",
    overview:
      "HEXAD LTD provides multidisciplinary consultancy and technical support services that help organizations improve performance, solve operational challenges, strengthen project delivery, and achieve sustainable growth. Our team combines practical experience, technical expertise, and industry knowledge to provide strategic guidance, technical assessments, project support, training, and operational advisory services across multiple sectors. We work closely with clients to identify challenges, develop practical solutions, and support successful implementation.",
    whatWeProvide: [
      "Project planning and management advisory",
      "Engineering and technical advisory",
      "Transport and logistics advisory",
      "Procurement and supply chain support",
      "Operational improvement consulting",
      "Institutional capacity development",
      "Business and organizational support",
      "Implementation and field supervision",
      "Training & capacity building programs",
      "Monitoring and evaluation support",
    ],
    problemsSolved: [
      "Addressing weak project planning and implementation frameworks",
      "Filling technical capacity gaps in organizations",
      "Improving operational inefficiencies and workflow bottlenecks",
      "Strengthening coordination among project stakeholders",
      "Supporting compliance and implementation challenge resolution",
      "Improving resource management and allocation",
    ],
    features: [
      {
        title: "Feasibility Studies",
        description:
          "We assist organizations in evaluating project viability, identifying risks, assessing opportunities, and supporting informed decision-making.",
      },
      {
        title: "Technical Assessments",
        description:
          "Our team conducts technical evaluations to identify strengths, weaknesses, operational gaps, and improvement opportunities.",
      },
      {
        title: "Business & Operational Planning",
        description:
          "We support organizations in developing practical plans, implementation frameworks, and operational strategies.",
      },
      {
        title: "Training & Capacity Building",
        description:
          "HEXAD provides training programs designed to strengthen technical skills, operational effectiveness, and project management capabilities.",
      },
      {
        title: "Compliance Support",
        description:
          "We assist clients in understanding and meeting regulatory, procurement, operational, and project requirements.",
      },
      {
        title: "Field Supervision & Coordination",
        description:
          "Our specialists provide on-site supervision, coordination, and technical oversight to ensure successful implementation.",
      },
    ],
    industriesServed: [
      {
        name: "Agriculture",
        description:
          "Technical support for agricultural supply chains, institutional programs, and operational initiatives.",
      },
      {
        name: "Government Institutions",
        description:
          "Advisory and implementation support for public sector projects and procurement activities.",
      },
      {
        name: "NGOs & Development Organizations",
        description:
          "Technical assistance, project support, training, and operational advisory services for donor-funded programs.",
      },
      {
        name: "Construction & Infrastructure",
        description:
          "Engineering support, technical supervision, project planning, and implementation guidance.",
      },
      {
        name: "Manufacturing & Production",
        description:
          "Operational support, process improvement, and technical advisory services.",
      },
      {
        name: "SMEs & Private Sector",
        description:
          "Business support, operational planning, project implementation, and organizational development services.",
      },
    ],
    whyChooseHexad: [
      {
        title: "Multidisciplinary Expertise",
        description:
          "Our team combines knowledge across engineering, transport, project management, procurement, operations, and implementation.",
      },
      {
        title: "Practical Experience",
        description:
          "We provide solutions grounded in real-world project execution and operational management experience.",
      },
      {
        title: "Implementation-Oriented Approach",
        description:
          "We go beyond recommendations by supporting clients throughout implementation and execution phases.",
      },
      {
        title: "Training & Knowledge Transfer",
        description:
          "We focus on building long-term organizational capacity and sustainable improvement.",
      },
      {
        title: "Client-Centred Solutions",
        description:
          "Every engagement is tailored to the unique needs, objectives, and operating environment of the client.",
      },
    ],
    portfolioHighlights: [
      "Government procurement and supply project advisory",
      "Infrastructure and civil works technical support",
      "Educational institution support programs",
      "Agricultural supply and operational project advisory",
      "NGO-funded implementation initiative support",
      "Multi-sector operational experience with repeat engagements",
    ],
    geographicCoverage: [
      "Kigali",
      "Musanze",
      "Gicumbi",
      "Ruhango",
      "Nyamasheke",
      "Nyanza",
      "Rwamagana",
      "Muhanga",
      "Nationwide coverage",
    ],
    majorClients: [
      "Government Institutions",
      "District Administrations",
      "NGOs and Development Partners",
      "Educational Institutions",
      "Agricultural Organizations",
      "Private Sector Businesses",
    ],
    faq: [
      {
        q: "Do you provide on-site support?",
        a: "Yes. HEXAD provides field supervision, project coordination, technical monitoring, and on-site advisory services where required.",
      },
      {
        q: "Can services be delivered remotely?",
        a: "Yes. Depending on project requirements, consultancy, planning, reporting, training, and advisory services can be delivered remotely.",
      },
      {
        q: "Do you offer ongoing advisory support?",
        a: "Yes. We can provide continuous technical assistance and advisory services throughout project implementation and operational improvement initiatives.",
      },
      {
        q: "Do you provide training services?",
        a: "Yes. Capacity building and training are core components of our technical support services.",
      },
      {
        q: "Can you support organizations during project implementation?",
        a: "Yes. HEXAD provides technical guidance, supervision, coordination, monitoring, and implementation support throughout the project lifecycle.",
      },
    ],
  },
  {
    id: 5,
    title: "Animal Feed Production",
    subtitle: "Agribusiness",
    image:
      "https://i.pinimg.com/1200x/c7/48/6e/c7486e17101054423bb8ded68225212d.jpg",
    description:
      "Quality-certified animal feed manufactured at our Gatsibo District factory. We produce a full range of feeds for poultry, swine, and dairy cattle — formulated to maximise animal health and productivity.",
    overview:
      "HEXAD LTD operates an animal feed manufacturing plant in Gatsibo District, Eastern Province, Rwanda. We produce a comprehensive range of quality-certified feeds for poultry, swine, and dairy cattle — scientifically formulated to maximise animal health, growth rates, and productivity. Our production facility applies strict quality control standards at every stage to ensure each batch meets the nutritional requirements of modern commercial and smallholder livestock farming. We supply farms, cooperatives, and institutional agricultural programs across Rwanda.",
    products: [
      "Layer Starter Mash",
      "Pre-Starter Mash",
      "Grower Mash",
      "Pre-Layer Mash",
      "Layer 2",
      "Broiler Starter Mash",
      "Broiler Starter Pellet",
      "Broiler Finisher Mash",
      "Broiler Finisher Pellet",
      "Pig Starter Mash",
      "Pig Finisher Mash",
      "Lactating Sows",
      "Dairy Meal Mash",
    ],
    whatWeProvide: [
      "Animal feed manufacturing for poultry, swine, and dairy cattle",
      "Full product range covering all growth stages",
      "Bulk supply to commercial farms and cooperatives",
      "Supply to government agricultural institutions and programs",
      "Delivery across Gatsibo District and Eastern Province",
      "Nutritional guidance and product selection support for farmers",
    ],
    problemsSolved: [
      "Eliminating inconsistent feed quality from unregulated suppliers",
      "Reducing dependence on expensive imported feeds",
      "Improving access to quality feeds in rural Eastern Province",
      "Supporting better animal health and growth rates",
      "Providing reliable bulk supply for institutional agricultural programs",
      "Reducing feed costs through local production",
    ],
    features: [
      {
        title: "Quality-Certified Production",
        description:
          "All feeds are manufactured under strict quality controls, ensuring consistent nutritional value in every batch.",
      },
      {
        title: "Full Product Range",
        description:
          "13 product categories covering starter, grower, and finisher stages for layers, broilers, pigs, and dairy cattle.",
      },
      {
        title: "Local Manufacturing",
        description:
          "Our Gatsibo District factory enables faster delivery and fresher product for farms across Eastern Province.",
      },
      {
        title: "Scientifically Formulated",
        description:
          "Feeds are nutritionally balanced and formulated to maximise animal performance and profitability for farmers.",
      },
      {
        title: "Bulk Supply Capability",
        description:
          "We supply in bulk quantities for commercial farms, cooperatives, and large institutional agricultural programs.",
      },
      {
        title: "Institutional Supply",
        description:
          "We have experience supplying animal feeds under government agricultural contracts and development programs.",
      },
    ],
    industriesServed: [
      {
        name: "Poultry Farming",
        description:
          "Feeds for layer and broiler operations at all production stages, from starter through finisher.",
      },
      {
        name: "Pig Farming",
        description:
          "Starter and finisher feeds formulated for optimal swine growth, plus specialist lactating sow feed.",
      },
      {
        name: "Dairy Farming",
        description:
          "Dairy Meal Mash formulated to support milk production and overall cattle health.",
      },
      {
        name: "Government Agricultural Programs",
        description:
          "Institutional supply of animal feeds for government-run livestock support and development programs.",
      },
      {
        name: "Agricultural Cooperatives",
        description:
          "Bulk supply partnerships with farmer cooperatives to improve feed access and reduce individual farm costs.",
      },
    ],
    whyChooseHexad: [
      {
        title: "Locally Manufactured",
        description:
          "Produced in Rwanda, at our Gatsibo District factory, reducing supply chain delays and keeping costs competitive.",
      },
      {
        title: "Complete Product Portfolio",
        description:
          "One supplier for all your feed needs — layers, broilers, pigs, and dairy — across all growth stages.",
      },
      {
        title: "Consistent Quality",
        description:
          "Strict production controls ensure every batch delivers reliable nutritional performance for your animals.",
      },
      {
        title: "Institutional Track Record",
        description:
          "Proven experience supplying animal feeds under government agricultural contracts and programs.",
      },
      {
        title: "Accessible Location",
        description:
          "Our Gatsibo factory serves Eastern Province farms efficiently, with nationwide supply available for bulk orders.",
      },
    ],
    portfolioHighlights: [
      "Animal feed supply contracts for government agricultural programs",
      "Supply to poultry and livestock farms across Eastern Province",
      "Partnerships with agricultural cooperatives and farming groups",
      "Continuous supply of 13 product categories to institutional buyers",
    ],
    geographicCoverage: [
      "Gatsibo District (Factory Location)",
      "Eastern Province",
      "Kayonza",
      "Rwamagana",
      "Nationwide delivery available for bulk orders",
    ],
    majorClients: [
      "Government Agricultural Institutions",
      "Commercial Poultry Farms",
      "Pig Farming Cooperatives",
      "Dairy Farmers",
      "Agricultural Development Programs",
    ],
    faq: [
      {
        q: "What animals do your feeds support?",
        a: "Our feeds support layers, broilers, pigs (including lactating sows), and dairy cattle across all production stages.",
      },
      {
        q: "Do you supply in bulk for commercial farms?",
        a: "Yes, we supply in bulk quantities for commercial farms, cooperatives, and institutional agricultural buyers.",
      },
      {
        q: "Are your products quality certified?",
        a: "Yes. Our feeds are manufactured following Rwanda Standards Board quality guidelines with strict in-house quality controls.",
      },
      {
        q: "Do you offer delivery?",
        a: "Yes, we deliver to farms across Gatsibo and the Eastern Province. Nationwide delivery is available for bulk orders.",
      },
      {
        q: "Can I visit the factory?",
        a: "Yes. We welcome visits from farmers, buyers, and institutional partners. Please contact us to arrange a visit to our Gatsibo plant.",
      },
    ],
  },
  {
    id: 6,
    title: "Construction Services",
    subtitle: "Construction",
    image: "/images/construction.jpg",
    description:
      "Full-scale construction solutions for residential and commercial properties. You provide the requirements and materials, and we handle the complete construction process — from foundation to finishing — with skilled labour and quality workmanship.",
    overview:
      "HEXAD LTD provides comprehensive construction services for residential and commercial projects across Rwanda. Our approach is client-driven — you provide the requirements, designs, and materials, and we take full responsibility for the construction process. We manage everything from site preparation and foundation work through to structural completion and finishing, ensuring quality workmanship at every stage. Our team combines skilled labour, experienced supervisors, and disciplined project management to deliver results that meet your specifications, timeline, and budget. Whether you're building a private residence, commercial property, or institutional facility, HEXAD brings reliability, transparency, and quality to every project we undertake.",
    whatWeProvide: [
      "Residential construction services",
      "Commercial building construction",
      "Institutional facility construction",
      "Site preparation and foundation works",
      "Structural construction and masonry",
      "Roofing and finishing works",
      "Interior and exterior finishing",
      "Project supervision and quality control",
      "Labour management and coordination",
      "Construction timeline management",
    ],
    problemsSolved: [
      "Removing the burden of managing construction labour and supervision",
      "Ensuring consistent workmanship and quality control",
      "Reducing construction delays through effective project coordination",
      "Eliminating miscommunication between owners and workers",
      "Providing reliable on-site supervision and quality assurance",
      "Delivering predictable project outcomes with clear timelines",
    ],
    features: [
      {
        title: "Client-Provided Materials",
        description:
          "You supply the materials and requirements — we handle all the labour, supervision, and construction execution.",
      },
      {
        title: "End-to-End Construction",
        description:
          "From foundation and structural work to roofing, finishing, and handover — we manage the entire construction process.",
      },
      {
        title: "Skilled Workforce",
        description:
          "Our team includes experienced masons, carpenters, plumbers, electricians, and general labourers.",
      },
      {
        title: "On-Site Supervision",
        description:
          "Every project is supervised by experienced construction managers who ensure quality and progress.",
      },
      {
        title: "Quality Assurance",
        description:
          "We maintain high workmanship standards through continuous inspection and quality control.",
      },
      {
        title: "Timeline Management",
        description:
          "We work to clearly defined schedules, coordinating resources and labour to meet project deadlines.",
      },
    ],
    industriesServed: [
      {
        name: "Residential",
        description:
          "Private homes, villas, and residential compounds built to client specifications and preferences.",
      },
      {
        name: "Commercial",
        description:
          "Office buildings, retail spaces, and commercial facilities requiring professional construction.",
      },
      {
        name: "Institutional",
        description:
          "Schools, healthcare facilities, government buildings, and community infrastructure.",
      },
      {
        name: "Real Estate Development",
        description:
          "Construction support for property developers and real estate investment projects.",
      },
    ],
    whyChooseHexad: [
      {
        title: "You Control the Materials",
        description:
          "You provide the materials you want, ensuring your project uses exactly the quality and specifications you require.",
      },
      {
        title: "We Handle the Workforce",
        description:
          "We manage all labour recruitment, coordination, supervision, and payments — you don't have to worry about managing workers.",
      },
      {
        title: "Quality Workmanship",
        description:
          "We take pride in delivering high-quality construction with attention to detail at every stage.",
      },
      {
        title: "Experienced Supervision",
        description:
          "Our supervisors ensure work is done correctly, safely, and according to your specifications.",
      },
      {
        title: "Transparent Process",
        description:
          "We maintain clear communication about progress, challenges, and timelines throughout the project.",
      },
    ],
    portfolioHighlights: [
      "Residential construction projects",
      "Commercial building construction",
      "Institutional facility development",
      "Renovation and improvement projects",
      "Construction management for client-supplied materials",
    ],
    geographicCoverage: [
      "Kigali",
      "Muhanga",
      "Musanze",
      "Eastern Province",
      "Nationwide coverage available",
    ],
    majorClients: [
      "Private Homeowners",
      "Commercial Property Owners",
      "Institutional Clients",
      "Real Estate Developers",
    ],
    faq: [
      {
        q: "Do I need to provide all materials?",
        a: "Yes. Our construction service is designed around you supplying the materials, while we handle all labour, supervision, and construction execution. This gives you full control over material quality and costs.",
      },
      {
        q: "What types of buildings do you construct?",
        a: "We construct residential homes, commercial buildings, institutional facilities, and community infrastructure projects.",
      },
      {
        q: "Do you provide project supervision?",
        a: "Yes. Every project has an experienced construction supervisor on-site to ensure quality, safety, and progress.",
      },
      {
        q: "How do you ensure quality?",
        a: "Through continuous on-site inspection, skilled workforce management, and adherence to construction best practices.",
      },
      {
        q: "Do you work on renovation projects?",
        a: "Yes, we also undertake renovation, remodelling, and improvement projects for existing buildings.",
      },
    ],
  },
  {
    id: 7,
    title: "Transport & Logistics",
    subtitle: "Logistics",
    image:
      "https://i.pinimg.com/736x/16/81/bf/1681bfdaca3c9fed3c1417683cb7ca39.jpg",
    description:
      "Reliable transport services for both goods and people. Whether you need to move cargo across locations or arrange passenger transport for events and ceremonies, we provide well-maintained vehicles and professional drivers to ensure safe and timely delivery.",
    overview:
      "HEXAD LTD provides dependable transport and logistics solutions for both goods and people across Rwanda. Our services are designed to meet the diverse mobility needs of individuals, businesses, institutions, and event organizers. Whether you need to transport construction materials, agricultural products, or general cargo from one location to another, or require passenger transport for ceremonies, corporate events, or group travel, we provide well-maintained vehicles, professional drivers, and reliable service. Our transport solutions are built on safety, punctuality, and customer satisfaction — ensuring your goods or people arrive safely and on time.",
    whatWeProvide: [
      "Goods transport and cargo delivery",
      "Passenger transport for events and ceremonies",
      "Corporate and group transport",
      "Construction material haulage",
      "Agricultural product transport",
      "General logistics coordination",
      "Vehicle and driver hire",
      "Event transport planning and coordination",
      "Reliable and professional drivers",
      "Safe and well-maintained vehicles",
    ],
    problemsSolved: [
      "Solving unreliable cargo and goods transportation",
      "Providing professional transport for ceremonies and events",
      "Eliminating delays in material delivery to project sites",
      "Reducing transport coordination stress for events",
      "Ensuring safe and timely passenger transportation",
      "Providing dependable logistics for businesses and institutions",
    ],
    features: [
      {
        title: "Goods Transport",
        description:
          "We transport construction materials, agricultural products, commodities, and general cargo across Rwanda.",
      },
      {
        title: "Passenger Transport",
        description:
          "We provide passenger vehicles with professional drivers for events, ceremonies, corporate travel, and group outings.",
      },
      {
        title: "Event Transport Services",
        description:
          "We coordinate transport logistics for weddings, funerals, corporate events, and large gatherings.",
      },
      {
        title: "Professional Drivers",
        description:
          "All our drivers are experienced, licensed, and committed to safety and punctuality.",
      },
      {
        title: "Well-Maintained Fleet",
        description:
          "Our vehicles are regularly serviced and inspected to ensure reliability and passenger/cargo safety.",
      },
      {
        title: "Nationwide Coverage",
        description:
          "We provide transport services across Kigali and all districts of Rwanda, including remote and rural areas.",
      },
    ],
    industriesServed: [
      {
        name: "Individuals & Families",
        description:
          "Passenger transport for personal travel, ceremonies, and family events.",
      },
      {
        name: "Corporate & Business",
        description:
          "Corporate transport, staff movement, and logistics support for businesses.",
      },
      {
        name: "Construction",
        description:
          "Transport of construction materials to project sites across the country.",
      },
      {
        name: "Agriculture",
        description:
          "Haulage of agricultural inputs, produce, and livestock feed to and from farms.",
      },
      {
        name: "Institutions",
        description:
          "Transport support for schools, hospitals, government offices, and NGOs.",
      },
      {
        name: "Event Management",
        description:
          "Transport coordination for weddings, funerals, conferences, and community events.",
      },
    ],
    whyChooseHexad: [
      {
        title: "Reliable Service",
        description:
          "We are committed to punctuality, safety, and delivering on our transport commitments every time.",
      },
      {
        title: "Professional Drivers",
        description:
          "All drivers are trained, licensed, experienced, and customer-focused.",
      },
      {
        title: "Well-Maintained Vehicles",
        description:
          "Our fleet is regularly maintained to ensure safety, comfort, and reliability.",
      },
      {
        title: "Flexible Solutions",
        description:
          "We accommodate both one-time transport needs and recurring logistics requirements.",
      },
      {
        title: "Nationwide Reach",
        description:
          "We operate across all districts of Rwanda, including remote and hard-to-reach locations.",
      },
      {
        title: "Competitive Pricing",
        description:
          "We offer affordable transport solutions without compromising quality or safety.",
      },
    ],
    portfolioHighlights: [
      "Goods transport for construction materials across multiple districts",
      "Passenger transport coordination for ceremonies and events",
      "Agricultural product haulage for farms and institutions",
      "Corporate transport for staff and business operations",
      "Logistics support for institutional supply chains",
      "Event transport coordination for large gatherings and ceremonies",
    ],
    geographicCoverage: [
      "Kigali",
      "Musanze",
      "Gicumbi",
      "Ruhango",
      "Nyamasheke",
      "Nyanza",
      "Rwamagana",
      "Muhanga",
      "Gatsibo",
      "Kayonza",
      "All districts nationwide",
    ],
    majorClients: [
      "Private Individuals",
      "Corporate Clients",
      "Event Organizers",
      "Construction Companies",
      "Agricultural Cooperatives",
      "Institutions and NGOs",
    ],
    faq: [
      {
        q: "What types of goods do you transport?",
        a: "We transport construction materials, agricultural products, commodities, furniture, and general cargo across Rwanda.",
      },
      {
        q: "Do you provide passenger transport for ceremonies?",
        a: "Yes. We provide passenger transport with professional drivers for weddings, funerals, corporate events, and other ceremonies.",
      },
      {
        q: "Can you handle large group transport?",
        a: "Yes, we can coordinate transport for large groups. Please contact us with your specific requirements.",
      },
      {
        q: "Are your vehicles well-maintained?",
        a: "Yes. We maintain a regular service and inspection schedule to ensure all vehicles are safe, clean, and reliable.",
      },
      {
        q: "How do I book transport services?",
        a: "You can contact us directly to discuss your requirements, receive a quotation, and book your transport service.",
      },
      {
        q: "Do you provide transport nationwide?",
        a: "Yes. We provide transport services across all districts of Rwanda, including rural and hard-to-reach areas.",
      },
    ],
  },
];
